import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, FormBuilder, NgForm, Validators,FormArray } from '@angular/forms';
import {MyserviceService} from '../myservice.service';
import {Router} from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers:[MyserviceService],
})
export class LoginComponent implements OnInit {

  loginForm:FormGroup;
  constructor(private fb: FormBuilder,private router:Router,private serv:MyserviceService) { }
  ngOnInit(): void {
    this.loginForm=this.fb.group({
      username:[null,[Validators.required,Validators.minLength(8)]],
      password:[null,[Validators.required]]
    });
  }
  login_data={
    username:'',
    password:''
  }
  val:boolean=false;
  user:any;
  submit(){
    console.log(this.loginForm);
    this.login_data={
      username:this.loginForm.controls.username.value,
      password:this.loginForm.controls.password.value
    };

    this.serv.userLogin(this.login_data.username).subscribe(
      data=>{
        console.log("User Is LogedIn");
        this.user=data;
        console.log("dsds "+this.user.name);
        console.log("dsds "+this.user.email);
        if(this.user.password==this.login_data.password){
          this.val=false;
          localStorage.setItem('log','true');
          localStorage.setItem('loginUser',JSON.stringify(this.user));
          alert("you are logged in");
          this.router.navigate(['user']);
        }
        else{
          this.val=true;
          localStorage.setItem('log','false');
          this.router.navigate(['login']);
        }

      },
      error=>{
        this.val=true;
        console.log("Error");
      }
    )
  }

}
